import * as ContactsActions from '../actions/contacts.actions';
import * as ContactsState from '../states/contacts.state';

export class State extends ContactsState.State { }

const initialState: ContactsState.State = ContactsState.initialState;

/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {ContactsActions.Actions} action
 * @returns {ContactsState.State}
 */
export function reducer(state = initialState, action: ContactsActions.Actions): ContactsState.State {

	switch (action.type) {
		case ContactsActions.ActionTypes.LOADING:
			state = Object.assign({}, state, { loading: true, contacts: [] });
			return state;
		case ContactsActions.ActionTypes.PUT_CONTACT:
			state = Object.assign({}, state, { loading: false, contacts: action.payload });
			return state;
		default:
			return state;
	}
}

export const getLoading = (state: ContactsState.State) => state.loading || [];
export const getContacts = (state: ContactsState.State) => state.contacts || [];
